/**
 * Copyright (C) 2019 HERE Global B.V. and its affiliate(s).
 * All rights reserved.
 *
 * This software and other materials contain proprietary information
 * controlled by HERE and are protected by applicable copyright legislation.
 * Any use and utilization of this software and other materials and
 * disclosure to any third parties is conditional upon having a separate
 * agreement with HERE for the access, use, utilization or disclosure of this
 * software. In the absence of such agreement, the use of the software is not
 * allowed.
 */

import LuiBase from '@here/lui-base'
import scopedCss from 'lui-navigationdrawer.scss'
import template from 'lui-navigationdrawer.html'

export default class LuiNavigation extends LuiBase {
  static get is() {
    return 'lui-navigationdrawer'
  }

  static get css() {
    return scopedCss
  }

  static get template() {
    return template
  }
}



//////////////////
// WEBPACK FOOTER
// ./packages/lui-navigation/lui-navigationdrawer.js
// module id = 257
// module chunks = 0 1 9